// extracted by mini-css-extract-plugin
export default {"close-icon":"modal_close-icon__Yre7g","modal-wrapper":"modal_modal-wrapper__PNni8"};